/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ApplicationDocumentType {
    OFFER = 'OFFER',
    ORDER = 'ORDER',
    ADDITIONAL = 'ADDITIONAL',
}
